import React from 'react';
import { useEffect, useState } from 'react';

import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';

import { Typography, Button } from '@mui/material';
import { supabase } from '../../../../api';
import { PROFILE_TABLE } from '../../../../constants/supabase_constants';

const StepOneForm = (props) => {
  const [loading, setLoading] = useState(true);
  //eslint-disable-next-line
  const [completed, setCompleted] = useState(true);
  const [confirmOpen, setConfirmOpen] = useState(false);

  useEffect(() => {
    getProfile();
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async () => {
    updateProfile();
    props.handleNext();

    const user = supabase.auth.user();

    // Send to AWS user workflow
    const url = process.env.REACT_APP_AWS_ENDPOINT;
    const data = {
      // eslint-disable-next-line
      input: `{\"MembershipType\": \"MEMBER\", \"Email\": \"${user.email}\", \"Status\": \"Applied\"}`,
      name: 'Applied_' + user.email,
      stateMachineArn: process.env.REACT_APP_AWS_STATE_MACHINE,
    };

    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: {},
        body: JSON.stringify(data),
      });
      console.log(res);
    } catch (error) {
      console.log(error);
    }
  };

  const handleConfirmOpen = (e) => {
    e.preventDefault();
    setConfirmOpen(true);
    return false;
  };

  const getProfile = async () => {
    try {
      setLoading(true);
      const user = supabase.auth.user();

      let { data, error, status } = await supabase
        .from(PROFILE_TABLE)
        .select(
          `fullName, title, about, age, skills, companyName, companyAbout, companyLink, founded, revenue, teamSize, industry, linkedin, email, addressLine1, postalCode`,
        )
        .eq('id', user.id)
        .single();

      if (error && status !== 406) {
        throw error;
      }

      if (data) {
        for (const property in data) {
          if (data[property] === '' || data[property] === null) {
            setCompleted(false);
            break;
          }
        }
      } else {
        setCompleted(false);
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async (e) => {
    try {
      setLoading(true);
      const user = supabase.auth.user();

      const updates = {
        id: user.id,
        membershipLevel: 'applied',
      };

      let { error } = await supabase.from(PROFILE_TABLE).upsert(updates, {
        returning: 'minimal',
      });

      if (error) {
        throw error;
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      {loading ? (
        'Saving ...'
      ) : (
        <React.Fragment>
          <Typography variant='h5' sx={{ mt: '3rem', mb: 1, fontWeight: 'bold' }}>
            Cohort 002 Applications
          </Typography>
          <Typography variant='body1'>
            This is the application for Cohort 002, which starts in October. Results will be released at the end of
            September. We will notify you via email.
          </Typography>
          <Typography variant='body1' sx={{ mt: '1rem', fontWeight: 'bold' }}>
            Complete all fields in "Edit Profile" and submit your application.
          </Typography>
          <Typography variant='body1' sx={{ mt: '1rem' }}>
            Email us at hello@the100club.io if there are any issues.
          </Typography>
          {/* <form onSubmit={formik.handleSubmit}> */}
          <form onSubmit={handleConfirmOpen}>
            <Button
              disabled={completed === false}
              // disabled
              color='primary'
              variant='contained'
              fullWidth
              type='submit'
              sx={{ mt: '1rem' }}>
              Submit
              <ConfirmDialog title='Final Check' open={confirmOpen} setOpen={setConfirmOpen} onConfirm={handleSubmit}>
                Are you sure you want to submit your application?
              </ConfirmDialog>
            </Button>
          </form>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default StepOneForm;
